import { AnimatePresence } from "motion/react";

import { useTheme } from "@up/data";
import { Toggle } from "@up/ui";

import { useCart } from "./CartContext";
import GuardianInformationDisplay from "./GuardianInformationDisplay";
import GuardianInformationForm from "./GuardianInformationForm";

import type { TCart } from "@up/data";

type Props = {
  cart: TCart;
  showGuardianEmail: boolean;
};

const guardianDataIsValid = function (cart?: TCart): boolean {
  const errors = cart?.errors ?? [];
  const guardianErrors = errors
    .filter((e) => {
      return typeof e.path[0] === "string";
    })
    .map((e) => {
      const path = e.path[0] as string;
      return path.match(/^guardian/);
    })
    .filter((m) => Boolean(m));

  return !guardianErrors.length;
};

export const GuardianSection = function GuardianSection({
  cart,
  showGuardianEmail,
}: Props) {
  const theme = useTheme();
  const { updateCart } = useCart();

  return (
    <Toggle>
      {(showForm, setShowForm) => {
        return (
          <section
            id="guardian-section"
            className="checkout-section scroll-mt-16 mb-16"
          >
            <div className="mb-2 flex items-center">
              <h2 className={`checkout-heading ${theme.heading2Class}`}>
                Guardian Information
              </h2>
              <button
                className="ml-3 cursor-pointer rounded border border-solid border-gray-400 bg-transparent px-3 py-1 text-sm text-inherit"
                data-testid="guardian-edit-button"
                onClick={() => {
                  setShowForm(!showForm);
                }}
              >
                Edit
              </button>
            </div>

            <AnimatePresence>
              {showForm || !guardianDataIsValid(cart) ? (
                <GuardianInformationForm
                  key="GuardianInformationForm"
                  showGuardianEmail={showGuardianEmail}
                  cancelFn={() => {
                    setShowForm(false);
                  }}
                  guardian={
                    cart.guardian || {
                      firstName: "",
                      lastName: "",
                      email: "",
                    }
                  }
                  saveSuccess={(updatedCart) => {
                    updateCart(updatedCart);
                    setShowForm(false);
                  }}
                />
              ) : (
                <GuardianInformationDisplay guardian={cart.guardian} />
              )}
            </AnimatePresence>
          </section>
        );
      }}
    </Toggle>
  );
};
